import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBoundryService } from '@secca/core/services/dialog-boundry.service';
import { FraudDocumentAnalysis } from '@secca/shared/models/atlas/atlas-fraud-detection.model';

export interface AtlasFraudDocumentReportDialogData {
  documentAnalysis: FraudDocumentAnalysis;
}

@Component({
  selector: 'app-atlas-fraud-document-report-dialog',
  templateUrl: './atlas-fraud-document-report-dialog.component.html',
  styleUrls: ['./atlas-fraud-document-report-dialog.component.scss'],
  standalone: false
})
export class AtlasFraudDocumentReportDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AtlasFraudDocumentReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AtlasFraudDocumentReportDialogData,
    public dialogBoundryService: DialogBoundryService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get documentAnalysis(): FraudDocumentAnalysis {
    return this.data.documentAnalysis;
  }

  get tags(): string {
    return (this.documentAnalysis?.tags || []).filter(Boolean).join(', ') || '-';
  }

  get size(): string {
    return Array.isArray(this.documentAnalysis?.size) && this.documentAnalysis.size.length
      ? this.documentAnalysis.size.join(' x ')
      : '-';
  }

  hasObjectValue(value: Record<string, unknown> | null | undefined): boolean {
    return !!value && Object.keys(value).length > 0;
  }

  formatObject(value: Record<string, unknown> | null | undefined): string {
    return value ? JSON.stringify(value, null, 2) : '';
  }
}
